import { REDUX_STATUS } from '@gymaholic/packages'

/**
 * Checks whether the given instance is saving.
 * @param   {Instance} instance
 * @returns {boolean}
 */
export default function isLoadingReduxUtil (instance) {
  return !!(instance && instance.status === REDUX_STATUS.LOADING)
}
